import React from "react";

import { ScreenFrame } from "components/onboarding/ScreenFrame";

const screenInfo = {
  buttonText: "Continuar",
  body: [
    "Opa, a sua concessionária de energia está sendo adicionada!",
    "Não se preocupe, vamos te notificar assim que a sua concessionária estiver disponível.",
  ],
  title: "Atenção!",
  nextScreen: "/onboarding/monitoring",
  dashboardScreen: "/admin/billing",
};

export const EnergyWaitlist = ({ history, location }) => {
  const handleButtonClick = () => {
    const returnToDashboard = location.state?.returnToDashboard;
    returnToDashboard
      ? history.replace(screenInfo.dashboardScreen)
      : history.push(screenInfo.nextScreen);
  };

  return (
    <ScreenFrame
      body={screenInfo.body}
      buttonText={screenInfo.buttonText}
      onClick={handleButtonClick}
      title={screenInfo.title}
      variant="success"
    />
  );
};
